// Vendor js
import './vendor';

// Application js
import Vue from 'vue';
import VueRouter from 'vue-router';

// import components
import SearchVue from './components/search.vue';
import AdminVue from './components/admin.vue';
import AdvancedSearchVue from './components/advancedSearch.vue';
import DetailOverlayVue from './components/detailOverlay.vue';
import PageNotFound from './components/pageNotFound.vue';

// import directives
import InfiniteScroll from './directives/infiniteScroll.js';
import IncrementalScroll from './directives/incrementalScroll.js';
import PreventScroll from './directives/preventScroll.js';

// Build vue router with mappings
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    { path: '/', redirect: { name: 'search' } },
    { path: '/admin', component: AdminVue, name: 'admin' },
    { path: '/advancedsearch', component: AdvancedSearchVue, name: 'advanced' },
    {
      path: '/search',
       component: SearchVue,
       name: 'search',
       children: [
         {
           path: '/object/:id',
          name: 'object',
          component: DetailOverlayVue
        }
      ]
    },
    { path: '*', component: PageNotFound, name: '404' }
  ]
});

// Register custom Directives
Vue.directive('infinite-scroll', InfiniteScroll);
Vue.directive('incremental-scroll', IncrementalScroll);
Vue.directive('prevent-scroll', PreventScroll);

// Set up google analytics
// Update this code based on the latest Google Analytics documentation
// Example: https://developers.google.com/analytics/devguides/collection/analyticsjs
// Initialize Google Analytics with your tracking ID
// ga('create', 'UA-10033645-6', 'auto');
// ga('require', 'displayfeatures');
// ga('set', 'appName', 'Catalogs Search');

// start application
const app = new Vue({
  el: '#app',
  router
});


// Store the user's browser
//document.documentElement.setAttribute('is-webkit', '-webkit-line-clamp' in document.body.style);
